import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button as MuiButton, styled, Typography } from '@mui/material';

import { DasIdWillAssign, PlantWillAssign } from '../../../../types';

import AddSvgIcon from '../../../../assets/SvgIcon/AddSvgIcon';

import ConnectedDeviceCard from './ConnectedDeviceCard';

const Container = styled('div')`
  height: calc(100% - 80px);
  width: 100%;
`;

const ContainerContent = styled('div')`
  height: 100%;
  width: 100%;
  border-radius: 4px;
  margin-top: 8px;
`;

const ContentTitle = styled(Typography)`
  color: white;
  margin-bottom: 8px;
`;

const Content = styled('div')`
  border-radius: 4px;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  margin-top: 10px;
`;

const Button = styled(MuiButton)`
  text-transform: none;
  height: 40px;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: start;
  align-items: center;
  color: white;
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`;

interface ConnectedDeviceContentProps {
  handleDasIDWillAssign: (dasIds: Array<DasIdWillAssign>) => void;
  data: Array<DasIdWillAssign>;
  plantType?: PlantWillAssign['plantType'];
}

const ConnectedDeviceContent: React.FC<ConnectedDeviceContentProps> = ({
  handleDasIDWillAssign,
  data,
  plantType,
}) => {
  const { t } = useTranslation();
  const cards = data;
  const deviceType = plantType === 'roofProtection' ? 'dasrp' : 'dastrack';
  const deviceLabel = plantType === 'roofProtection' ? 'DasRP' : 'DasTrack';

  const handleAddCard = () => {
    const initPlantCard: DasIdWillAssign = {
      id: '',
      dasId: '',
      name: '',
      batteryLevel: 0,
      deviceType,
    };
    handleDasIDWillAssign([...cards, initPlantCard]);
  };

  const onChangeCard = (index: number, datas: DasIdWillAssign) => {
    const newDatas = [...cards];
    newDatas[index] = datas;
    handleDasIDWillAssign(newDatas);
  };

  const onDeleteCard = (index: number) => {
    const newcards = [...cards];
    newcards.splice(index, 1);
    handleDasIDWillAssign(newcards);
  };

  const items = cards.map((item, i) => (
    <ConnectedDeviceCard
      key={i}
      onChange={onChangeCard}
      onDeleteCard={onDeleteCard}
      connectedDasId={item}
      index={i}
      plantType={plantType}
    />
  ));

  return (
    <Container>
      <ContainerContent>
        <ContentTitle>
          {t(
            'project-settingJson.page.plant-management.dialog.create-plant.connected-device.title',
          )}
        </ContentTitle>
        <Button
          startIcon={<AddSvgIcon sx={{ width: '32px', height: '32px' }} />}
          onClick={handleAddCard}
        >
          {t(
            'project-settingJson.dialog.create-resource.connected-device.title-button',
            { deviceName: deviceLabel },
          )}
        </Button>
        <Content>{items}</Content>
      </ContainerContent>
    </Container>
  );
};

export default ConnectedDeviceContent;
